import { render, staticRenderFns } from "./StatusMovement.vue?vue&type=template&id=d8b9f6f6&"
import script from "./StatusMovement.vue?vue&type=script&lang=js&"
export * from "./StatusMovement.vue?vue&type=script&lang=js&"
import style0 from "./StatusMovement.vue?vue&type=style&index=0&id=d8b9f6f6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports